
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import Main from '@/components/Main.vue'
import Navigation from '@/components/Nav.vue'

export default defineComponent({
  name: 'App',
  components: {
    AppHeader: Header,
    AppMain: Main,
    Navigation
  }
})
